import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const { FiBell, FiX, FiInfo, FiCheckCircle, FiAlertTriangle, FiClock } = FiIcons;

export default function ActivityLogDrawer({ isOpen, onClose, activityLog }) {

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 z-40 backdrop-blur-sm"
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed top-0 right-0 bottom-0 w-[85%] max-w-sm bg-[#1c1c1d] z-50 border-l border-[#2c2c2e] flex flex-col shadow-2xl"
          >
            <div className="flex justify-between items-center p-4 border-b border-[#2c2c2e]">
              <h2 className="text-white font-bold flex items-center gap-2">
                <SafeIcon icon={FiClock} className="text-blue-400" />
                Activity Log
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-white bg-[#2c2c2e] p-1.5 rounded-full">
                <SafeIcon icon={FiX} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-3 scrollbar-hide">
              {activityLog.length === 0 ? (
                <div className="text-center text-gray-500 mt-10">
                  <SafeIcon icon={FiBell} className="text-3xl mx-auto mb-2 opacity-50" />
                  <p className="text-sm">No recent activity.</p>
                </div>
              ) : (
                activityLog.map(log => (
                  <div key={log.id} className="bg-[#0a0a0b] border border-[#2c2c2e] rounded-xl p-3">
                    <div className="flex items-start gap-3">
                      <div className={`mt-0.5 w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${
                        log.type === 'success' ? 'bg-green-500/20 text-green-400' :
                        log.type === 'error'   ? 'bg-red-500/20 text-red-400' :
                                                 'bg-blue-500/20 text-blue-400'
                      }`}>
                        <SafeIcon
                          icon={log.type === 'success' ? FiCheckCircle : log.type === 'error' ? FiAlertTriangle : FiInfo}
                          className="text-[10px]"
                        />
                      </div>
                      <div>
                        <h4 className="text-white text-xs font-bold mb-0.5">{log.title}</h4>
                        <p className="text-gray-400 text-[11px] leading-relaxed mb-1">{log.description}</p>
                        <span className="text-gray-600 text-[9px] font-mono">
                          {new Date(log.timestamp).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
